import { Error, PageLoading } from '@/components/shared';
import { MatterTab } from '@/components/matter';
import { SyncManagement } from '@/components/sync/SyncManagement';
import { useShellHeader, useShellHeaderBelow } from '@/components/contexts/ShellHeaderContext';
import NoCaseSelected from '@/components/shared/NoCaseSelected';
import { TooltipProvider } from "@/components/ui/tooltip";
import useMatter from '@/hooks/useMatter';
import { useMemo } from 'react';

const MatterSync = () => {
  const { isLoading, isError, matter: matterData } = useMatter();

  useShellHeader({
    header: matterData?.name ?? 'Loading matter...',
  });
  useShellHeaderBelow(
    useMemo(
      () => (matterData ? <MatterTab activeTab="sync" matter={matterData} /> : null),
      [matterData],
    ),
  );

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <Error message={isError.message} />;
  }

  if (!matterData) {
    return <NoCaseSelected />;
  }

  return (
    <TooltipProvider>
      <div className="flex h-full flex-col overflow-hidden">
        <div className="flex-1 min-h-0 overflow-y-auto px-6 pt-6 pb-4">
          <div className="mx-auto w-full max-w-4xl lg:pt-6">
            <SyncManagement matterGuid={matterData.guid} />
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
};
export default MatterSync;
